import mixpanel from 'mixpanel-browser';

const isProd = process.env.NODE_ENV === 'production';

const MIXPANEL_TOKEN = process.env.PUBLIC_MIXPANEL_TOKEN;

export const Mixpanel = {
	init: () => {
		if (!MIXPANEL_TOKEN) {
			// eslint-disable-next-line no-console
			console.warn('Mixpanel token is not defined.');
			return;
		}
		try {
			mixpanel.init(MIXPANEL_TOKEN, {
				autotrack: false,
				debug: !isProd,
				// eslint-disable-next-line camelcase
				track_pageview: false,
			});
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Mixpanel init', error);
		}
	},

	identify: (id: string) => {
		try {
			mixpanel.identify(id);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Mixpanel identify', error);
		}
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	track: (eventName: string, eventProperties: Record<string, any>) => {
		try {
			mixpanel.track(eventName, eventProperties);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Mixpanel track', eventName, error);
		} finally {
			if (!isProd) {
				// eslint-disable-next-line no-console
				console.log(`📊 Tracking "${eventName}"`);
			}
		}
	},

	reset: () => {
		try {
			mixpanel?.reset();
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Mixpanel reset', error);
		}
	},

	waitForAnalytics: (callback: () => void) => {
		const interval = setInterval(() => {
			if (mixpanel && typeof mixpanel.identify === 'function') {
				clearInterval(interval);
				callback();
			}
		}, 300);
	},
};
